import React from 'react';
import { ReactTyped } from 'react-typed';
import ToolBar from './ToolBar';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faLinkedin, faGithub } from "@fortawesome/free-brands-svg-icons";
import { ToolBarMenu } from '../utils/resource.utils';

const Header = () => {

  return (
    <header className="select-none">
      <div className="fixed border border-slate-300 ring-slate-300 bg-slate-100 shadow-md dark:ring-gray-900 z-10 p-2 rounded-lg bottom-3 left-1/2 -translate-x-1/2 bg-background dark:bg-gradient-to-r dark:from-black dark:to-slate-950 dark:border-slate-500">
        {/* {Toolbar menu for Navigation} */}
        <ToolBar ToolBarMenu={ToolBarMenu} />
      </div>

      <div className="relative min-h-[100svh] flex flex-col items-center justify-center gap-10 transition-all">
        <div className="absolute top-8 left-8 hidden md:block mb-5 bg-black hover:bg-opacity-85 text-slate-50 dark:bg-gray-800 dark:hover:bg-gray-900 border dark:border-gray-500 rounded-lg transition-all">
          <a
            className="inline-flex items-center justify-center tracking-wide rounded-md text-sm font-medium ring-offset-background transition-all duration-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2"
            target="_blank"
            href="https://drive.google.com/file/d/13cT-T9LbNYYCtnlzhfSrnJuGoCOF3ifo/view?usp=sharing"
            rel="noreferrer"
          >
            View Resume
          </a>
        </div>
        <div className="flex items-center gap-3 sm:gap-2 absolute top-12 md:top-8 md:right-8 md:translate-x-0 right-1/2 translate-x-1/2">
          <a
            aria-label="mail"
            className="inline-flex items-center justify-center lg:hover:bg-pink-50 hover:ring-1 hover:ring-slate-300 dark:bg-black dark:hover:bg-gray-800 rounded-md text-gray-800 font-medium ring-offset-background transition-opacity dark:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-12 p-2.75"
            target="_blank"
            rel="noreferrer"
            href="mailto:madalavrahulbabu123@gmail.com"
          >
            <FontAwesomeIcon icon={faEnvelope} size="2x" />
          </a>

          <a
            aria-label="linkedin"
            className="inline-flex items-center justify-center lg:hover:bg-pink-50 hover:ring-1 hover:ring-slate-300 dark:bg-black hover:dark:bg-gray-800 rounded-md text-gray-800 font-medium ring-offset-background transition-opacity dark:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-12 p-2.75"
            target="_blank"
            rel="noreferrer"
            href="https://www.linkedin.com/in/venkata-rahul-babu-madala-94293025b/"
          >
            <FontAwesomeIcon icon={faLinkedin} size="2x" />
          </a>

          <a
            aria-label="github"
            className="inline-flex items-center justify-center lg:hover:bg-pink-50 hover:ring-1 hover:ring-slate-300 dark:bg-black hover:dark:bg-gray-800 rounded-md text-gray-800 font-medium ring-offset-background transition-opacity dark:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-12 p-2.75"
            target="_blank"
            rel="noreferrer"
            href="https://github.com/venkataRahulbabu/"
          >
            <FontAwesomeIcon icon={faGithub} size="2x" />
          </a>
        </div>

        <div className="flex flex-col place-items-center gap-8 transition-all lg:translate-y-5 translate-y-8">
          <h1 className="text-45px sm:text-68px font-extrabold tracking-tight lg:text-90px leading-none transition-all p-2">
            <span className="whitespace-nowrap duration-500 ease-in-out transition bg-gradient-to-r from-[#ec71d4] to-[#8c84ff] bg-clip-text text-transparent">
              M V Rahul Babu
            </span>
          </h1>
          <div className="rounded-2xl shadow h-48 w-48 lg:h-56 lg:w-56 overflow-hidden transition-all">
            <img
              alt="profile"
              loading="lazy"
              width="320"
              height="300"
              decoding="async"
              data-nimg="1"
              className="object-cover h-48 w-48 lg:h-56 lg:w-56 scale-110 hover:scale-115 transition duration-700 ease-in-out bg-gray-50"
              style={{ color: "transparent" }}
              src="/images/profile_photo.jpeg"
            />
          </div>
        </div>

        <span className="lg:hidden text-2xl text-muted-foreground text-center font-medium mt-12 font-sans dark:text-slate-200 transition duration-100">
          <ReactTyped
            strings={[
              "Software Engineer at IBM",
              "Full Stack Developer",
              "Tech Enthusiast",
            ]}
            typeSpeed={50}
            backSpeed={50}
            loop
          />
        </span>

        <p className="hidden lg:block absolute bottom-6 left-8 lg:text-19px font-semibold font-sans dark:text-slate-100 transition duration-100">
          Software Developer and Tech Enthusiast
        </p>
        <p className="hidden lg:block absolute bottom-6 right-8 lg:text-19px font-semibold font-sans dark:text-slate-100 transition duration-100">
          Focused on building quality experiences
        </p>

        <div
          className="absolute left-0 top-0 -z-10 transform-gpu overflow-hidden blur-3xl transition-all"
          aria-hidden="true"
        >
          <div
            className="relative left-0 aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-10 dark:opacity-5 sm:w-[72.1875rem]"
            style={{
              clipPath:
                "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
            }}
          ></div>
        </div>

        <div
          className="absolute right-0 top-0 -z-10 transform-gpu overflow-hidden blur-3xl transition-all"
          aria-hidden="true"
        >
          <div
            className="relative right-0 aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-10 dark:opacity-10 sm:w-[72.1875rem]"
            style={{
              clipPath:
                "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
            }}
          ></div>
        </div>
      </div>
    </header>
  );
};

export default Header;